import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";
import { AuthLayout } from "../components/auth-layout";
import { Button } from "../components/ui/button";
import { FieldError, Input, Label } from "../components/ui/input";
import { authClient } from "../lib/auth";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: Login,
});

function Login() {
  const { redirect } = Route.useSearch();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [error, setError] = useState<string>();
  const [pending, setPending] = useState(false);

  return (
    <AuthLayout title="Sign in" description="Accounts are created by invitation only.">
      <form
        className="flex flex-col gap-4"
        onSubmit={async (e) => {
          e.preventDefault();
          const form = new FormData(e.currentTarget);
          setPending(true);
          setError(undefined);
          const { error } = await authClient.signIn.email({
            email: String(form.get("email")),
            password: String(form.get("password")),
          });
          setPending(false);
          if (error) return setError(error.message ?? "Sign-in failed");
          qc.clear();
          await navigate({ to: redirect?.startsWith("/") ? redirect : "/" });
        }}
      >
        <div className="flex flex-col gap-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" name="email" type="email" autoComplete="email" required />
        </div>
        <div className="flex flex-col gap-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            required
          />
        </div>
        <FieldError>{error}</FieldError>
        <Button type="submit" disabled={pending}>
          {pending ? "Signing in…" : "Sign in"}
        </Button>
        <Link
          to="/forgot-password"
          className="text-center text-sm text-muted-foreground hover:underline"
        >
          Forgot password?
        </Link>
      </form>
    </AuthLayout>
  );
}
